import { TextField, Tooltip } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { SharedFieldInputProps } from "./types";
import { useSession } from "app/hooks/useSession";
import { formatRelativeTimeFromNow, getUserDateTimePreferences, pickerFormatPlaceholder, toDateFnsPickerFormat, utcIsoToZonedPickerDate, zonedPickerDateToUtcIso } from "../services/dateTimePreferences";
import { useTranslation } from "react-i18next";
import { usePickerDraftValue } from "./usePickerDraftValue";

export function DateTimeFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    fullWidth = true,
    size = "small",
    disabled = false,
}: SharedFieldInputProps<string | null>) {
    const { data: user } = useSession();
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage || i18n.language || user?.preferredLanguage || "en";
    const preferences = getUserDateTimePreferences(user, language);
    const { pickerValue, handlePickerChange } = usePickerDraftValue(
        value,
        (fieldValue) => utcIsoToZonedPickerDate(fieldValue, preferences.timeZone),
        (date) => zonedPickerDateToUtcIso(date, preferences.timeZone),
        onChange
    );
    const relativeTime = formatRelativeTimeFromNow(value, {
        language,
    });

    return (
        <DateTimePicker
            value={pickerValue}
            inputFormat={toDateFnsPickerFormat(preferences.dateTimeFormat)}
            onChange={(date) => handlePickerChange(date as Date | null)}
            disabled={disabled}
            renderInput={(params) => (
                <Tooltip title={relativeTime}>
                    <TextField
                        {...params}
                        inputProps={{ ...params.inputProps, placeholder: pickerFormatPlaceholder(preferences.dateTimeFormat, language) }}
                        fullWidth={fullWidth}
                        size={size}
                        InputLabelProps={{ shrink: true }}
                        error={error}
                        helperText={helperText}
                    />
                </Tooltip>
            )}
        />
    );
}
